module.exports = __webpack_public_path__ + "img/user-profile.3286d313.png";